/**
 *	Redirect popup
 */

const url = window.location.href;
const popup = document.getElementsByClassName( 'redirect-popup-wrapper' )[ 0 ];

if ( url.includes( '?' ) ) {
	const params = new URLSearchParams( url.split( '?' )[ 1 ] );

	params.forEach( ( value, key ) => {
		if ( [ 'vehco', 'connexas', 'verilocation', 'isotrak', 'breathalock', 'transcan', 'framelogic', 'navkonzept', 'hepa', 'rtl', 'hubiofleet', 'fleetseek', 'dualtech', 'dualtechitaly', 'lpa', 'fleets', 'digicomm', 'temeno' ].includes( key ) && ( value === '' || value === '1' ) ) {
			console.log( 'Popup activated with vale: ' + key + ' ' + value ); // eslint-disable-line no-console
			popup.classList.add( 'active' );
		}
	} );

	const popupClose = document.getElementsByClassName( 'redirect-popup-close' );

	if ( popupClose.length > 0 ) {
		popupClose[ 0 ].onclick = function closePopup() {
			popup.classList.remove( 'active' );
		};
	}

	document.body.onclick = function closePopupOverlay( event ) {
		if ( event.target.isEqualNode( popup ) ) {
			popup.classList.remove( 'active' );
		}
	};
}
